module.exports = __webpack_public_path__ + "img/2-3.37b4e565.svg";